import { render } from "./Orders.vue?vue&type=template&id=d1788da0&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=d1788da0&lang=css"
import "./Orders.vue?vue&type=style&index=1&id=d1788da0&scoped=true&lang=css"
import "./Orders.vue?vue&type=style&index=2&id=d1788da0&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1788da0"]])

export default __exports__